module.exports = __webpack_public_path__ + "media/82.664dc22f.mp3";